import * as React from "react";
import { SVGProps } from "react";
export function IndustryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 19.819 19.815"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m19 10.396-8.532 3.93a1.4 1.4 0 0 1-1.16 0l-8.49-3.93M19 14.94l-8.532 3.93a1.4 1.4 0 0 1-1.16 0l-8.49-3.93m9.749-5.176a1.65 1.65 0 0 1-1.315 0L1.28 6.074a.783.783 0 0 1 0-1.399L9.253.955a1.65 1.65 0 0 1 1.314 0l7.972 3.692a.784.784 0 0 1 0 1.398l-7.972 3.72Z"
        stroke="#000"
        strokeWidth={1.636}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
